import TaxiCorporationAddRequest, {
  TaxiCorporationAddRequestBody,
} from "./taxi-corporation-add-request";

const createBody = (
  request: TaxiCorporationAddRequest
): TaxiCorporationAddRequestBody => {
  return {
    taxId: request.taxId,
    regon: request.regon,
    krsNo: request.krsNo,
    companyName: request.companyName,
    displayName: request.displayName,
    headquartersAddressString: request.headquartersAddressString,
    contractMaintenancePolicy: request.contractMaintenancePolicy,
    notes: request.notes,
  };
};

const taxiCorporationAddRequestFactory = {
  createBody,
};

export default taxiCorporationAddRequestFactory;
